import type { SystemSurfaceId } from "../contracts/system-surface";

export type AppState =
  | { kind: "booting" }
  | { kind: "home" }
  | { kind: "loading-game"; gameId: string }
  | { kind: "running-game"; gameId: string }
  | { kind: "recovering"; gameId: string; error: Error }
  | { kind: "loading-system-surface"; surfaceId: SystemSurfaceId }
  | { kind: "running-system-surface"; surfaceId: SystemSurfaceId }
  | { kind: "recovering-system-surface"; surfaceId: SystemSurfaceId; error: Error };

export type AppEvent =
  | { type: "boot-ready" }
  | { type: "select-game"; gameId: string }
  | { type: "game-ready"; gameId: string }
  | { type: "game-failed"; gameId: string; error: Error }
  | { type: "select-system-surface"; surfaceId: SystemSurfaceId }
  | { type: "system-surface-ready"; surfaceId: SystemSurfaceId }
  | { type: "system-surface-failed"; surfaceId: SystemSurfaceId; error: Error }
  | { type: "return-home" }
  | { type: "recover-home" };

export const initialAppState: AppState = { kind: "booting" };

export function reduceAppState(state: AppState, event: AppEvent): AppState {
  switch (state.kind) {
    case "booting":
      return event.type === "boot-ready" ? { kind: "home" } : state;

    case "home":
      if (event.type === "select-game") {
        return { kind: "loading-game", gameId: event.gameId };
      }
      if (event.type === "select-system-surface") {
        return { kind: "loading-system-surface", surfaceId: event.surfaceId };
      }
      return state;

    case "loading-game":
      if (event.type === "game-ready" && event.gameId === state.gameId) {
        return { kind: "running-game", gameId: state.gameId };
      }
      if (event.type === "game-failed" && event.gameId === state.gameId) {
        return { kind: "recovering", gameId: state.gameId, error: event.error };
      }
      if (event.type === "return-home") {
        return { kind: "home" };
      }
      return state;

    case "running-game":
      if (event.type === "return-home") {
        return { kind: "home" };
      }
      if (event.type === "game-failed" && event.gameId === state.gameId) {
        return { kind: "recovering", gameId: state.gameId, error: event.error };
      }
      return state;

    case "recovering":
      return event.type === "recover-home" ? { kind: "home" } : state;

    case "loading-system-surface":
      if (event.type === "system-surface-ready" && event.surfaceId === state.surfaceId) {
        return { kind: "running-system-surface", surfaceId: state.surfaceId };
      }
      if (event.type === "system-surface-failed" && event.surfaceId === state.surfaceId) {
        return {
          kind: "recovering-system-surface",
          surfaceId: state.surfaceId,
          error: event.error,
        };
      }
      if (event.type === "return-home") {
        return { kind: "home" };
      }
      return state;

    case "running-system-surface":
      if (event.type === "return-home") {
        return { kind: "home" };
      }
      if (event.type === "system-surface-failed" && event.surfaceId === state.surfaceId) {
        return {
          kind: "recovering-system-surface",
          surfaceId: state.surfaceId,
          error: event.error,
        };
      }
      return state;

    case "recovering-system-surface":
      return event.type === "recover-home" ? { kind: "home" } : state;
  }
}
